module.exports = __webpack_public_path__ + "static/media/main idea.5568382f.mp3";